import '../stylesheets/frontend/ranking.css.scss'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

import ReactOnRails from 'react-on-rails'
import MiniRateChartTable from '../bundles/components/MiniRateChartTable'
import WholeRateChartTable from '../bundles/components/WholeRateChartTable'

const application = Application.start()
const context = require.context(
  'controllers',
  true,
  /^(?!.*\/admin\/).*_controller\.(js|ts)$/
)
application.load(definitionsFromContext(context))

ReactOnRails.register({
  MiniRateChartTable,
  WholeRateChartTable,
})
